module.exports = __webpack_public_path__ + "img/1.6831019b.png";